export enum MediaType {
  Picture,
  Video,
  File
}
